import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { hooks } from "@vote4dance/judging-sdk";
import { AccessDenied } from "../../base-react/components/AccessDenied";
var SessionState = hooks.sessions.SessionState;
var useSession = hooks.sessions.useSession;
import { Loading } from "../../base-react/components/Loading";
import { useOrganization } from "../../base-react/hooks/Organization";
import { LoginForm } from "../../base-react/components/LoginForm";
export const OrganizationAdminOutlet = () => {
    const { organization_id } = useParams();
    const { loading, showAdmin } = useOrganization(organization_id);
    const sessionState = useSession();
    const isSystemAdministrator = SessionState.isSystemAdministrator(sessionState);
    if (!sessionState || !sessionState.sessionInfo || loading) {
        return React.createElement(Loading, null);
    }
    if (isSystemAdministrator || showAdmin) {
        return React.createElement(Outlet, null);
    }
    if (!sessionState.isLoggedIn) {
        return React.createElement(LoginForm, { compact: true });
    }
    return React.createElement(AccessDenied, null);
};
